import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { CheckIcon } from '@heroicons/react/20/solid';
export const Step = ({ children }) => {
    return _jsx("div", { children: children });
};
export const VerticalStepper = ({ activeStep, children }) => {
    if (!children)
        return null;
    return (_jsx("div", { className: "flex flex-col", children: React.Children.map(children, (child, index) => {
            if (!React.isValidElement(child)) {
                return null;
            }
            const childProps = child.props;
            return (_jsx("div", { className: "my-4 flex flex-col", children: _jsxs("div", { className: "flex flex-row px-2", children: [_jsx("span", { className: `${childProps.hideCounter ? 'invisible' : 'visible'} flex size-8 items-center justify-center rounded-full text-white ${activeStep + 1 > index ? 'bg-primary-400' : 'bg-blue-gray-200'}`, children: activeStep > index ? _jsx(CheckIcon, { className: "size-5" }) : _jsx("span", { className: " ", children: index + 1 }) }), _jsxs("div", { className: "flex w-full flex-col justify-center pl-4 pr-2 md:px-4", children: [_jsx("h1", { className: "mb-4 pt-1 text-xl font-semibold leading-7 tracking-tight text-gray-800", children: childProps?.label }), _jsx("div", { className: "w-full", children: childProps.children })] })] }) }, index));
        }) }));
};
//# sourceMappingURL=VerticalStepper.js.map